<script lang="ts">
  import { onMount } from "svelte";
  import CustomListSchemaDropdown from "../../components/Form/Fields/Dropdown/CustomListSchemaDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Label from "../../components/Form/Label.svelte";
  import Richtext from "../../components/Form/Fields/Richtext.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import Table from "../../components/Table/Table.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import { customListOwnershipsFields } from "../../utils/TableFields/custom-list-ownerships.fields";
  import {
    editing,
    init,
    loading,
    loadOwnerships,
    onCreate,
    onDelete,
    onEdit,
    record,
    records,
    save,
  } from "./settings-custom-list-ownerships.store";

  let canSubmit = true;

  $: isNew = $record != null && $record.oid === 0;


  async function onSubmit() {
    await save();
    editing.set(false);
    record.set(null);
  }

  function onCancel() {
    editing.set(false);
    record.set(null);
  }


  onMount(init);
</script>

{#if $editing === false}


  <GlobalErrors errors={[]} />

  <div style="padding-bottom: 2rem;">
    <Table
      loading={$loading}
      fields={customListOwnershipsFields}
      records={$records}
      pagination={null}
      createEnabled={true}
      editEnabled={true}
      deleteEnabled={false}
      on:create={(_) => onCreate()}
      on:edit={(e) => onEdit(e.detail)}
    />
  </div>
{:else if $record != null}
  <FormLayout on:submit={onSubmit} on:cancel={onCancel} {canSubmit} {isNew}>
    <FormField usageHelp="">
      <Input
        name="Nome"
        placeholder="nome"
        required={true}
        maxlength={200}
        bind:value={$record.name}
      />
    </FormField>

    <FormField
      usageHelp=""
    >
      <Input
        name="Path fatture da spedire"
        placeholder="path fatture da spedire"
        required={false}
        bind:value={$record.pathFattureDaSpedire}
      />
    </FormField>
    <FormField
      usageHelp=""
    >
      <Input
        name="Path fatture da archiviare"
        placeholder="path fatture da archiviare"
        required={false}
        bind:value={$record.pathFattureDaArchiviare}
      />
    </FormField>
    <FormField
      usageHelp=""
    >
      <Input
        name="Email mittente"
        placeholder="email mittente"
        required={false}
        bind:value={$record.emailMittente}
      />
    </FormField>

    <FormField
      usageHelp="Testo relativo all'oggetto della mail. E' possibile usare i placeholder (vedi sotto) per configurarlo"
    >
    <Textarea
    name="Template oggetto"
    placeholder="template oggetto"
    required={false}
    bind:value={$record.templateEmail}
    />

    </FormField>

    <FormField
      usageHelp="Testo relativo al corpo della mail. E' possibile usare i placeholder (vedi sotto) per configurarlo"
    >
    <Textarea
    name="Template corpo"
    placeholder="template corpo"
    required={false}
    bind:value={$record.templateBody}
    />

    </FormField>

    <FormField
      usageHelp="Testo relativo all'oggetto della mail ESTRATTO CONTO/SOLLECITO. E' possibile usare i placeholder (vedi sotto) per configurarlo"
    >
    <Textarea
    name="Template estrattoconto/sollecito oggetto"
    placeholder="template estrattoconto/sollecito oggetto"
    required={false}
    bind:value={$record.templateEmailSollecito}
    />
    </FormField>

    <FormField
      usageHelp="Testo relativo al corpo della mail ESTRATTO CONTO/SOLLECITO. E' possibile usare i placeholder (vedi sotto) per configurarlo"
    >
    <Textarea
    name="Template estrattoconto/sollecito corpo"
    placeholder="template estrattoconto/sollecito corpo"
    required={false}
    bind:value={$record.templateEmailSollecitoBody}
    />

    </FormField>

    <Label >
    Placeholder disponibili: &lt;ragionesociale&gt; &lt;codicefattura&gt; &lt;datafattura&gt; &lt;importofattura&gt;
    </Label>

    
    <FormField
      usageHelp="Path al template PDF per email di estratto conto"
    >
    <Input
    name="Path al template PDF"
    placeholder="path al template pdf"
    required={false}
    bind:value={$record.pathTemplatePdfEstrattoconto}
    />

    </FormField>
 
    <FormField
      usageHelp="Path al template PDF per pec di sollecito"
    >
    <Input
    name="Path al template PDF"
    placeholder="path al template pdf"
    required={false}
    bind:value={$record.pathTemplatePdfSollecito}
    />

    </FormField>

    <FormField
      usageHelp=""
    >
      <Input
        name="PEC mittente"
        placeholder="pec mittente"
        required={false}
        bind:value={$record.pecMittente}
      />
    </FormField>


  </FormLayout>
{/if}
